<template>
  <div class="row">
    <div class="col-md-12">
      <MostUsedMedicines />
    </div>
  </div>
</template>

<script>
import MostUsedMedicines from "./Charts/MostUsedMedicines";

export default {
  name: "Graphics",
  components: { MostUsedMedicines },
};
</script>
